import React from 'react';
import styled from 'styled-components';
import { mb, mt, pl } from '@nib/layout';
import Link from '@nib-components/link';
import { copyColor } from '@nib-components/theme';
import { YesNoRadio } from '../..';
import { AddFunnelPropFromContext } from '../funnel-context';
import slugify from 'slugify';
import { Stack } from '@nib/layout';
import Copy from '@nib-components/copy';
import { FUNNELS, LABELS as DEFAULT_LABELS } from '../../util/constants';
import { StandardInfoBox } from '../info-box';
const LABELS = {
  ARHI: DEFAULT_LABELS.PREEXISTING_CONDITIONS
};
const DUTY_OF_DISCLOSURE_LINKS = {
  ARHI: ['nib Privacy Policy', 'https://www.nib.com.au/docs/privacy-policy'],
  IWHI: ['nib Duty of Disclosure', 'https://www.nib.com.au/docs/ovhc-duty-of-disclosure'],
  IMAN: ['iman Duty of Disclosure', 'https://www.austhealth.com/duty-of-disclosure']
};
const INFO = 'Information you supply is subject to the ';
const CONDITIONS = ['Diabetes, high blood sugar, sugar in the urine', 'Injury to, or disorder of any joint, muscle or ligament', 'Any heart or circulatory condition, including but not limited to, high blood pressure, irregular heartbeat, heart attack or chest pain', 'Any type of cancer, tumour or blood disorder', 'Any disorders of the nervous system', 'Any other significant medical condition requiring ongoing monitoring or treatment', 'In the last 5 years been admitted to hospital for any reason', 'In the last 5 years taken any medication, other than the contraceptive pill or for cold or flu', 'In the last 5 years experienced any symptoms, or sought advice or treatment from any medical specialist for anything other than already answered above'];
const Ol = styled.ol`
  margin: 0;
  ${mt(5)};
  padding: 0;
  padding-left: 1em;
  font-size: 1rem;
  color: ${copyColor};
`;
const Li = styled.li`
  ${mb(4)};
  ${pl(2)};
`;
const ConditionsEnumeration = _ref => {
  let {
    conditions
  } = _ref;
  return React.createElement(Ol, null, conditions && conditions.map((value, index) => React.createElement(Li, {
    key: `pre-existing_condition_list_${index}`
  }, value)));
};
const DocumentLink = _ref2 => {
  let {
    funnel
  } = _ref2;
  const funnelLinks = funnel ? DUTY_OF_DISCLOSURE_LINKS[funnel] || DUTY_OF_DISCLOSURE_LINKS.ARHI : DUTY_OF_DISCLOSURE_LINKS.ARHI;
  const link = funnelLinks[1];
  const text = funnelLinks[0];
  return React.createElement(Link, {
    href: link,
    id: `ga-inlink-${slugify(link, {
      lower: true
    })}`,
    target: "_blank"
  }, text);
};
const PreExistingHealthCondition = props => {
  const {
    funnel = FUNNELS.ARHI,
    width = 20,
    optional = false
  } = props;
  const help = props.help ? props.help : React.createElement(ConditionsEnumeration, {
    conditions: CONDITIONS
  });
  return React.createElement(Stack, {
    space: 2
  }, React.createElement(YesNoRadio, {
    ...props,
    label: props.label || LABELS[funnel] || LABELS.ARHI,
    funnel: funnel,
    width: width,
    help: help,
    optional: optional
  }), React.createElement(StandardInfoBox, {
    withTip: true
  }, React.createElement(Copy, null, INFO, React.createElement(DocumentLink, {
    funnel: funnel
  }))));
};
const PreExistingHealthConditionWithFunnel = props => React.createElement(AddFunnelPropFromContext, null, React.createElement(PreExistingHealthCondition, {
  ...props
}));
export default PreExistingHealthConditionWithFunnel;